import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  const emitVisibility = (visible: boolean) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('forfeo-cookie-consent-visibility', {
          detail: { visible },
        })
      );
    }
  };

  useEffect(() => {
    try {
      // Vérifie si l'utilisateur a déjà accepté
      const consent = localStorage.getItem('cookie-consent');
      const shouldShow = !consent;
      setShow(shouldShow);
      emitVisibility(shouldShow);
    } catch {
      // Fallback si localStorage est bloqué (mode privé / restrictions)
      setShow(true);
      emitVisibility(true);
    }
  }, []);

  const acceptCookies = () => {
    try {
      localStorage.setItem('cookie-consent', 'true');
    } catch {
      // no-op (on ferme quand même la bannière)
    }
    setShow(false);
    emitVisibility(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed left-0 right-0 bottom-0 md:left-0 md:right-0 md:bottom-0 bg-slate-800/95 backdrop-blur-md text-white p-3 md:p-4 shadow-2xl z-[9998] animate-fade-in-up border border-white/10 md:border-x-0 md:border-b-0 rounded-3xl md:rounded-none"
      role="dialog"
      aria-live="polite"
      aria-label="Consentement des cookies"
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
        <p className="text-xs md:text-sm text-gray-300 text-center md:text-left leading-relaxed max-h-[4.8rem] overflow-hidden md:max-h-none">
          Nous utilisons des cookies techniques pour le fonctionnement de la carte Google Maps, la géolocalisation et une meilleure expérience Forfeo Explore.
        </p>

        <button
          onClick={acceptCookies}
          className="bg-blue-600 hover:bg-blue-500 text-white px-7 py-2.5 md:px-6 md:py-2 rounded-full font-bold text-sm transition shadow-lg whitespace-nowrap w-full md:w-auto"
        >
          Accepter
        </button>
      </div>
    </div>
  );
}
